<template>
  <div id="dev-main">
    <section class="hero is-medium is-primary is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Build Connected Strength Training Products
          </h1>
          <h2 class="subtitle">
            ShapeLog API
          </h2>
        </div>
      </div>
    </section>

    <div id="use-cases" class="tile is-ancestor">
      <div class="tile is-4 is-vertical is-parent">
        <div class="tile is-child box">
          <img src="@/assets/icon_asset_mgmt_blue.svg" >
          <p class="title">Asset Management</p>
          <p>Helps equipment manufacturers, gym and club owners
            understand how their equipment is being utilized.</p>
        </div>
        <div class="tile is-child box">
          <img src="@/assets/icon_asset_mgmt_blue.svg" >
          <p class="title">Individual &amp; Group Training</p>
          <p>Enable trainers to build workouts, perform strength
            assessments, run classes, and view client data.</p>
        </div>
      </div>
      <div class="tile is-4 is-vertical is-parent">
        <div class="tile is-child box">
          <img src="@/assets/icon_asset_mgmt_blue.svg" >
          <p class="title">Marketing Intelligence</p>
          <p>Gain insights to inform targeted marketing campaigns
            and get a better understanding of who's doing what.</p>
        </div>
        <div class="tile is-child box">
          <img src="@/assets/icon_asset_mgmt_blue.svg" >
          <p class="title">Coaching</p>
          <p>By reverse engineering the successful path that top performers
            have taken, you’ll be able to tell everyone what they should do next.</p>
        </div>
      </div>
    </div>

    <div id="markets" class="tile is-ancestor">
      <div class="tile is-12 is-horizontal is-parent">
        <div id="bicep" class="tile is-4 is-child">
          <img src="@/assets/bicep_man.png" >
        </div>
        <div id="geriatric" class="tile is-4 is-child">
          <img src="@/assets/geriatric_man.png" >
        </div>
        <div id="pectoral" class="tile is-4 is-child">
          <img src="@/assets/pectoral_man.png" >
        </div>
      </div>
    </div>

    <div id="about" class="tile is-ancestor">
      <div class="tile is-12 is-horizontal is-parent">
        <div class="tile is-6 is-child">
          <p class="title">SHAPELOG POWERS NEXT-GENERATION FITNESS EXPERIENCES</p>
          <p>We are a fitness technology startup in Ann Arbor, MI with backgrounds
            in software, hardware, machine learning, events, and exercise science.</p>

            <p>We partner with fitness equipment manufacturers to identify, learn about,
              and delight users at the gym or at home. By collecting high-resolution workout
              data, we learn about you, and offer evidence-based programming that has the
              potential to change your life forever.</p>
        </div>
        <div class="tile is-6 is-child">
          <img src="@/assets/shapelog_team.png" >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dev-main',
  methods: {
    apiClick() {
      this.$root.$emit('set-view', 'ApiDocs');
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/styles/common.scss';

  #dev-main {
    height: 95vh;
    overflow: scroll;
  }

  .clickable {
    cursor: pointer;
  }

  .hero-body {
    background-image: url('../assets/sli_api_header.jpg');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    .title,
    .subtitle {
      text-shadow: 2px 2px #000000;
    }
  }

  #use-cases {
    margin-top: 30px;
    text-align: center;
    justify-content: center;

    .box {
      padding-left: 2rem;
      padding-right: 2rem;
    }

    p.title {
      font-weight: $font-weight-light;
    }
  }

  #markets {
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 0;
    margin-bottom: 0;

    img {
      width: 100%;
      height: 100%
    }

    div.tile {
      padding: 0;

    }

    #bicep {
      padding-right: 1px;
    }

    #geriatric {
      padding-left: 1px;
      padding-right: 1px;
    }

    #pectoral {
      padding-left: 1px;
    }
  }

  #about {
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 2px;
    margin-bottom: 0;
    background-color: #4a4a4a;
    padding-top: 50px;

    div.tile {
      padding: 0;
    }

    .title {
      color: $white;
      font-size: 14px;
    }

    p {
      color: $white;
      text-align: left;
      padding-left: 50px;
      padding-right: 50px;
      margin-bottom: 20px;
    }
    img {
      padding-right: 50px;
      padding-left: 50px;
      padding-bottom: 50px;
    }
  }
</style>
